import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

import { VirtualCardTypesResponse } from './virtualCardTypes.types'

interface OrganizationVirtualCardTypesOptions
  extends ExtendBaseQueryOptions<VirtualCardTypesResponse, string[]> {
  orgId: string | undefined
}

export const useQueryOrganizationVirtualCardTypes = ({
  orgId,
  enabled = true,
  ...rest
}: OrganizationVirtualCardTypesOptions) => {
  return useExtendQuery<VirtualCardTypesResponse, string[]>({
    queryKey: orgQueryKeys.virtualCardTypes(orgId),
    queryUrl: () => `/organizations/${orgId}/virtualcardtypes`,
    select: (data) => data.virtualCardTypes,
    enabled: enabled && !!orgId,
    ...rest,
  })
}

interface OrganizationBillPayEnabledOptions
  extends ExtendBaseQueryOptions<VirtualCardTypesResponse, boolean> {
  orgId: string | undefined
}

// Org-level Bill Pay entry-point gate. Funding-source-specific behavior, like
// declining-balance amount locking, comes from /creditcards features.
export const useQueryOrganizationBillPayEnabled = ({
  orgId,
  enabled = true,
  ...rest
}: OrganizationBillPayEnabledOptions) => {
  return useExtendQuery<VirtualCardTypesResponse, boolean>({
    queryKey: orgQueryKeys.virtualCardTypes(orgId),
    queryUrl: () => `/organizations/${orgId}/virtualcardtypes`,
    select: (data) => data.billPayEnabled,
    enabled: enabled && !!orgId,
    ...rest,
  })
}
